import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { WcbQueueType } from '../types/WcbQueueType';
import WcbQueueSelect from './WcbQueueSelect';
import { IconArrowDown } from '../common/svgicons/ArrowDown';
import { getTranslation } from '../../constants/languages';
import { getPageExceptionTranslation } from '../../constants/siteIds';

type WcbQueueContainerProps = {
    iimclient: ConfigClientType;
    wcbQueues: Array<WcbQueueType>;
    wcbQueueErrorVisible?: boolean;
    queueSelectDisabled?: boolean;
    selectedQueueId?: string;
    changeSelectedQueueId: Function;
};

// Currently only fin had an error message
const CallbackSelectedQueueValidationError = {
    lang_no: null,
    lang_se: null,
    lang_fi: 'Aihe pitää valita',
    lang_dk: null,
    lang_en: null,
};

const WcbQueueContainer = ({
    iimclient,
    wcbQueues,
    wcbQueueErrorVisible,
    queueSelectDisabled,
    selectedQueueId,
    changeSelectedQueueId,
}: WcbQueueContainerProps) => {
    const { segment, lang } = iimclient;

    const displayLabel = segment && segment.labelquestion;
    const questionLabel = (segment && segment.labelquestion) || 'wcb-labelquestion';
    const queueIdRequiredLabel =
        (segment && segment.queueidrequired) ||
        getTranslation(lang, CallbackSelectedQueueValidationError);

    return (
        <div className="input-block" id="wcb-questions-container">
            {displayLabel && (
                <label htmlFor="wcb-queueid" id="wcb-labelquestion">
                    {questionLabel}
                </label>
            )}
            <div className="select-input">
                <WcbQueueSelect
                    iimclient={iimclient}
                    wcbQueues={wcbQueues}
                    isDisabled={queueSelectDisabled}
                    selectedQueueId={selectedQueueId}
                    changeSelectedQueueId={changeSelectedQueueId}
                />
                {/* <IconArrowDown width="28px" height="28px" color="#333" /> */}
            </div>
            {wcbQueueErrorVisible && (
                <div id="wcb-queueid-error" className="errorMessage">
                    {queueIdRequiredLabel}
                </div>
            )}
        </div>
    );
};

export default WcbQueueContainer;
